/* eslint-disable @typescript-eslint/naming-convention -- temporary */

export enum EntityTypeVsAssetClass {
  WorkflowDefinition = 'WORKFLOW_DEFINITION', // Automations
  CallableInterface = 'CALLABLE_INTERFACE', // Automation Interfaces
  NoCodeInterface = 'e_interface', // Interfaces
  WorkflowLibrary = 'TEMPLATE',
  PipelineConfig = 'DATA_PIPELINE',
  EntityType = 'ENTITY_TYPE', // ObjectManager
  ApiReport = 'API_REPORT',
  APIEndpointCollection = 'API_ENDPOINT_COLLECTION',
  APIEndpoint = 'API_ENDPOINT',
  APIPolicy = 'API_POLICY',
  APIClient = 'API_CLIENT',
  StandardWorkflowDefinition = 'STANDARD_WORKFLOW_DEFINITION',
  e_campaign = 'e_campaign',
  e_decision_table = 'e_decision_table',
  e_code_snippet = 'e_code_snippet',
  e_template = 'e_template',
  e_streams = 'e_streams',
  knowledge = 'knowledge',
  knowledge_set = 'knowledge_set',
  memory_set = 'memory_profile_set',
  memory_profile = 'memoryprofile',
  memories = 'memory_json_store',
  memory_profile_instructions_templates = 'memory_profile_instructions_templates',
  CopilotFeedback = 'service_hub_user_feedback',
  ai_agent_deployment = 'ai_agent_deployment',
  ai_agent = 'ai_agent',
  agent_profile = 'agent_profile',
  IdentityProvider = 'IDENTITY_PROVIDER',
  prompt = 'prompt',
  e_prerequisite_task_ai_agent = 'e_prerequisite_task_ai_agent',
  e_action_ai_agent = 'e_action_ai_agent',
  e_topic_ai_agent = 'e_topic_ai_agent',
  e_topic_app_library = 'e_topic_app_library',
  e_skill_ai_agent = 'e_skill_ai_agent',
  e_skill_group_ai_agent = 'e_skill_group_ai_agent',
  e_ai_agent_trigger_template = 'e_ai_agent_trigger_template',
  e_ai_agent_publish_template = 'e_ai_agent_publish_template',
  AccessProfile = 'ACCESS_PROFILE',
  SegmentDefinition = 'SEGMENT_DEFINITION',
  AlertDefinition = 'ALERT_DEFINITION',
  User = 'USER',
  Copilot = 'CO_PILOT',
  BusinessHours = 'e_business_hours',
  BusinessHolidays = 'e_business_holiday',
  EnvironmentVariables = 'e_env_variables',
  Connection = 'CONNECTION', // Connection Manager
  ConnectorDefinition = 'CONNECTOR_DEFINITION', // Connectors SDK
  CustomerEnvironment = 'CUSTOMER_ENVIRONMENT',
  Teams = 'USER_GROUP',
  Roles = 'ROLE_DEFINITION',
  ChangesetRequest = 'CHANGESET_REQUEST', // Inbound Change Set
  Changeset = 'CHANGESET', // Outbound Change Set
  Project = 's_project',
  UnifiedEntityAccessControl = 'UNIFIED_ENTITY_ACCESS_CONTROL',
  UnifiedEntityModel = 'UNIFIED_ENTITY_MODEL',
  Guardrail = 'gaurd_rail',
  Tenant = 'TENANT',
  AIModels = 'ai_agent_llm_model',
  e_knowledge_mime_type = 'e_knowledge_mime_type',
  ThemeBuilder = 'THEME_BUILDER',
  // Gates the project-level Theme Manager page (design-system route) and the no-code
  // interface theme-builder modals. Distinct from ThemeBuilder (platform settings theme
  // builder); value `e_theme` matches the underlying theme entity type (THEME_ENTITY_TYPE).
  ThemeManager = 'e_theme',
  CopilotConfig = 'co_pilot_config',
  ChatConfig = 'e_generic_chat_config',
  DataCatalog = 'e_data_catalog',
  DataCatalogApplication = 'e_data_catalog_application',
  AITeamTask = 'e_ai_team_task',
  AIAgentsSettings = 'e_ai_agent_settings',
  SearchRecord = 'SEARCH_RECORD',
  A2AServer = 'e_a2a_server',
  A2AAgentCard = 'e_agent_card',
  A2AServerSkill = 'e_a2a_server_skill',
  MCPServer = 'e_mcp_server',
  MCPServerResource = 'e_mcp_server_resource',
  MCPServerTool = 'e_mcp_server_tool',
  Prompt = 'e_prompt',
  MCPServerPrompt = 'e_mcp_server_prompt',
  IdentityMapping = 'app_people_mapping',
  AIAgentAuthor = 'ai_agent_people',
  PersonIndexingDetails = 'people_indexer_schema',
  Dataset = 'dataset',
  DatasetScenario = 'eval_dataset_scenario',
  EvaluationMetric = 'e_ai_evaluation_metric',
  EvaluationMetricSchema = 'e_ai_evaluation_metric_schema',
  EvaluationMetricLibrary = 'e_ai_evaluation_metric_library',
  Experiment = 'experiment',
  ConversationalTestCase = 'conversational_test_case',
  LLMTestCase = 'llm_test_case',
  UnitTestCase = 'UNIT_TEST_CASE',
  UnitTestSuite = 'UNIT_TEST_SUITE',
  UnitTestPlan = 'UNIT_TEST_PLAN',
  UnitTestDataset = 'UNIT_TEST_DATASET',
  DatasetImportHistory = 'dataset_import_history',
  ExperimentRuns = 'experiment_runs',
  ExperimentTestCaseRuns = 'test_case_runs',
  MDM = 'MDM_MODEL',
  ExternalAgentTemplate = 'external_agent_template',
  AIAgentDepartment = 'e_ai_agent_department',
  EnterpriseSearch = 'ENTERPRISE_SEARCH',
  RulesConfig = 'dq_rules_config',
  DataQualityMonitoringExperiment = 'data_quality_monitoring_experiment',
  TermsConfig = 'data_quality_business_term',
  DataQualityScan = 'data_quality_scans',
  DataQualityAssetScan = 'data_quality_asset_scan',
  DataQualityAssets = 'data_quality_assets',
  DataQualityRecordReport = 'data_quality_record_report',
  DataQualityLLMRuleKnowledge = 'data_quality_llm_rule_knowledge',
  Evaluation = 'EVALUATION',
  Settings = 'settings',
  HelpAndSupport = 'HELP_AND_SUPPORT',
  ServiceHubCase = 'service_hub_case',
  ServiceHubAttachment = 'service_hub_attachment',
  MasterChunkMetadata = 'master_chunk_metadata',
  KnowledgeSourceOutputSchema = 'knowledge_source_output_schema',
  KnowledgeSource = 'knowledge_source',
  DataBackup = 'PLATFORM_BACKUP_CONFIG',
  Space = 'e_space',
  KnowledgeVectorStoreOpenAI = 'knowledge_vector_store_open_ai_3072',
  KnowledgeReportingEntityDetails = 'knowledge_reporting_entity_details',
  CustomComponent = 'e_custom_component',
  AgenticAIConnections = 'agentic_ai_connections',
  AISpending = 'AGENT_SPENDING_LIMITS',
  AgentSpendingLimits = 'e_agent_spending_limits',
  AIAgentLimit = 'e_ai_agent_limit',
  TAG = 'TAG',
  ContextGraph = 'KNOWLEDGE_CONTEXT_GRAPH',
  ContextGraphSource = 'KNOWLEDGE_GRAPH_SOURCE',
  // FILTER_VIEW permission asset class — gates the saved table-views feature (views live in s_filter_views)
  FilterView = 'e_filter_view',
  // Enterprise Search · Governance entities
  Controls = 'controls',
  Policies = 'policies',
}

export type CustomEntityType = string;

export enum Permission {
  ALL = 'ALL',
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  CLONE = 'CLONE',
  DELETE = 'DELETE',
  DEPLOY = 'DEPLOY',
  EXECUTE = 'EXECUTE',
  EXPORT = 'EXPORT',
  IMPORT = 'IMPORT',
  APPROVE = 'APPROVE',
  READ = 'READ',
  EXPORT_AS_TEMPLATE = 'EXPORT_AS_TEMPLATE',
  TEST = 'TEST',
  VIEW_RUNS = 'VIEW_RUNS',
  ARCHIVE = 'ARCHIVE',
  VIEW = 'VIEW',
  SHARE = 'SHARE',
  ROLLBACK = 'ROLLBACK',
  VIEW_REPORT = 'VIEW_REPORT',
  SWITCH_TENANT = 'SWITCH_TENANT',
  PUBLISH = 'PUBLISH',
  RESET_PASSWORD = 'RESET_PASSWORD',
  USE = 'USE',
  MANAGE_LOCALIZATION = 'MANAGE_LOCALIZATION',
  SWITCH_MODEL = 'SWITCH_MODEL',
  VIEW_INSIGHTS = 'VIEW_INSIGHTS',
  VIEW_SETTINGS = 'VIEW_SETTINGS',
  VIEW_ALL_RUNS = 'VIEW_ALL_RUNS',
  RAW_QUERY_ACTION = 'RAW_QUERY_ACTION',

  // AI Agents
  ADVANCED_AGENT = 'ADVANCED',
  SIMPLE_AGENT = 'SIMPLE',
  GUARDRAILS = 'GUARDRAILS',
  AGENT_SETTINGS = 'AGENT_SETTINGS',
  AGENT_TASKS = 'AGENT_TASKS',
  VIEW_OBSERVABILITY = 'VIEW_OBSERVABILITY',
  VIEW_PII = 'VIEW_PII',

  // Event Streams
  PUBLISH_TO_DLQ = 'PUBLISH_TO_DLQ',

  // Objects
  STANDARD = 'STANDARD',
  DECRYPT = 'DECRYPT',

  // Ontology (MDM)
  STEWARD_EDIT = 'STEWARD_EDIT',
  STEWARD_VIEW = 'STEWARD_VIEW',
}
